module.exports = __webpack_public_path__ + "static/media/Flow-menu.c179729c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/Flow-menu.svg
// module id = 4083
// module chunks = 0